var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { buildCreateApplicationRequest } from './create_application_payload';
import { SUCCESS_STATUS_CODE } from './service_helpers';
var EMPTY_PAYLOAD_MESSAGE = 'There is nothing to submit yet. Please complete the form.';
var NO_PROGRAM_MESSAGE = 'This application has no program on it. Please start it from the Start Application dialog so the program is known.';
var FAILED_MESSAGE = 'The application could not be submitted. Please try again.';
export var submitCreateApplication = function (payload, files) { return __awaiter(void 0, void 0, void 0, function () {
    var request, response, applicationId, error_1;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                if (!payload.customers.length) {
                    return [2, { isSuccess: false, message: EMPTY_PAYLOAD_MESSAGE }];
                }
                request = buildCreateApplicationRequest(payload);
                if (!request.ProgramAspireOId || !request.ProgramId) {
                    return [2, { isSuccess: false, message: NO_PROGRAM_MESSAGE }];
                }
                _e.label = 1;
            case 1:
                _e.trys.push([1, 3, , 4]);
                return [4, api_service.post({
                        endPoint: api_urls.CREATE_APPLICATION,
                        payLoad: request,
                        showLoader: true,
                    })];
            case 2:
                response = _e.sent();
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                    return [2, {
                            isSuccess: false,
                            message: String((_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : FAILED_MESSAGE),
                        }];
                }
                applicationId = (_d = response.data.data) === null || _d === void 0 ? void 0 : _d.ApplicationId;
                return [2, {
                        isSuccess: true,
                        message: applicationId
                            ? "Application ".concat(applicationId, " submitted successfully.")
                            : 'Application submitted successfully.',
                    }];
            case 3:
                error_1 = _e.sent();
                return [2, { isSuccess: false, message: FAILED_MESSAGE }];
            case 4: return [2];
        }
    });
}); };
